/** Apply a Move (rule.md §6). */
import type { MoveAction } from "../types/action";
import type { AugmentedWarState, Unit } from "../types/game-state";
import { finalize, spendAction } from "./shared";

export function applyMove(
  state: AugmentedWarState,
  action: MoveAction,
): AugmentedWarState {
  const unit = state.board[action.from];
  if (!unit) return state; // unreachable post-validation
  const board: Record<string, Unit> = { ...state.board };
  delete board[action.from];
  board[action.to] = unit;
  return finalize({ ...state, board, ...spendAction(state, "move") });
}
